import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeConfigDataValue, getReachEstimate } from 'redux/modules/audience';
import { getCustomAudiences, setValue } from 'redux/modules/customAudiences';
import * as _ from 'lodash';
import AutoComplete from 'material-ui/AutoComplete';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import Chip from 'material-ui/Chip';
import { Spinner, Tooltip } from 'components';
import CABuilder from './CustomAudienceBuilder/CABuilder';
import * as styles from './Audiences.scss';
var AudienceCustom = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    audience: state.audience,
    includedCustomAudiences: state.audience && state.audience.FacebookTargetingConfig ? state.audience.FacebookTargetingConfig.data.custom_audiences : [],
    excludedCustomAudiences: state.audience && state.audience.FacebookTargetingConfig ? state.audience.FacebookTargetingConfig.data.excluded_custom_audiences : [],
    customAudiences: state.customAudiences && state.customAudiences.customAudiences[orgId] ? state.customAudiences.customAudiences[orgId] : null,
    gettingCustomAudiences: state.customAudiences.gettingCustomAudiences,
    audienceType: state.customAudiences.audienceType,
    theme: state.theme,
    organization: state.organization.current
  };
}, {
  changeConfigDataValue: changeConfigDataValue,
  getReachEstimate: getReachEstimate,
  getCustomAudiences: getCustomAudiences,
  setValue: setValue
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceCustom, _Component);

  var _super = _createSuper(AudienceCustom);

  function AudienceCustom(props) {
    var _this;

    _classCallCheck(this, AudienceCustom);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "includedCustomAudiencesChange", function (val) {
      var orgId = _this.props.organization.id;

      _this.props.changeAdBuilderValue(orgId, {
        includedCustomAudiences: val
      });

      _this.fetchAudienceData();
    });

    _defineProperty(_assertThisInitialized(_this), "excludedCustomAudiencesChange", function (val) {
      var orgId = _this.props.organization.id;

      _this.props.changeAdBuilderValue(orgId, {
        excludedCustomAudiences: val
      });

      _this.fetchAudienceData();
    });

    _defineProperty(_assertThisInitialized(_this), "handleIncludedCustomAudienceChipDelete", function (val) {
      var newAudiences = _this.props.includedCustomAudiences.filter(function (audience) {
        return val.id !== audience.id;
      });

      _this.includedCustomAudiencesChange(newAudiences);
    });

    _defineProperty(_assertThisInitialized(_this), "handleExcludedCustomAudienceChipDelete", function (val) {
      var newAudiences = _this.props.excludedCustomAudiences.filter(function (audience) {
        return val.id !== audience.id;
      });

      _this.excludedCustomAudiencesChange(newAudiences);
    });

    _defineProperty(_assertThisInitialized(_this), "addCustomAudience", function () {
      var type = _this.state.selectedCustomAudienceType;
      var orgId = _this.props.organization.id;
      var audience = _this.state.selectedCustomAudience ? _this.state.selectedCustomAudience : _this.props.customAudiences[0];

      if (type === 1) {
        _this.includedCustomAudiencesChange([].concat(_toConsumableArray(_this.props.includedCustomAudiences), [audience]).filter(function (o) {
          return o;
        }));
      } else {
        _this.excludedCustomAudiencesChange([].concat(_toConsumableArray(_this.props.excludedCustomAudiences), [audience]).filter(function (o) {
          return o;
        }));
      }

      _this.setState({
        selectedCustomAudience: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdvancedTargeting", function () {
      var pixels = _this.props.facebookPixels;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6 col-md-3"
      }, /*#__PURE__*/React.createElement("p", null, "Pixel Targeting", ' ', /*#__PURE__*/React.createElement(Tooltip, {
        name: "pixel_targeting_helper",
        message: "Facebook pixels allow you to target people that have visited your website."
      })), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Target people using Pixel",
        checked: _this.state.usePixelTargeting,
        onCheck: function onCheck() {
          var change = {
            usePixelTargeting: !_this.state.usePixelTargeting
          };

          if (change.usePixelTargeting === false) {
            change.selectedPixelId = null;
          }

          _this.setState(change);
        },
        style: {
          marginRight: 40,
          width: 'auto'
        }
      }), _this.state.usePixelTargeting && pixels.length > 0 && /*#__PURE__*/React.createElement(SelectField, {
        value: _this.state.selectedPixelId,
        hintText: "Select pixel",
        style: {
          top: 10
        },
        onChange: function onChange(e, i, val) {
          return _this.setState({
            selectedPixelId: val
          });
        }
      }, pixels.map(function (p, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "pixelMap_".concat(index),
          value: p.id,
          primaryText: p.name
        });
      })), _this.state.usePixelTargeting && pixels.length === 0 && /*#__PURE__*/React.createElement("p", null, "You don't have any Facebook pixels setup."))));
    });

    _this.state = {
      saveAudience: false,
      audienceModalDimensions: {},
      selectedCustomAudience: null,
      isCreatingCustomAudience: false,
      selectedCustomAudienceInputType: false,
      selectedCustomAudienceType: 1,
      showAudienceDialog: false
    };
    return _this;
  }

  _createClass(AudienceCustom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getCustomAudiences(this.props.organization.id, this.props.adAccountId);
    }
    /** *********************************************************
     RENDER
      return this.customAudienceBuilderRef
    .getWrappedInstance()
    .saveAudience()
     .then(() => {
      if (this.customAudienceField) {
        this.customAudienceField.value = null;
      }
      this.props.getCustomAudiences(this.props.organization.id);
      this.props.changeAdBuilderValue(this.props.organization.id, {
        newCustomAudienceName: ''
      });
      this.setState({
        isCreatingCustomAudience: false,
        customAudienceFile: null
      });
    });
    */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var includedCustomAudienceChips = this.props.includedCustomAudiences.map(function (chip, index) {
        return /*#__PURE__*/React.createElement(Chip, {
          key: "includedCAChip_".concat(index),
          style: {
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            var deletedIncludedAudiences = _this2.props.includedCustomAudiences.filter(function (a) {
              return parseInt(a) !== parseInt(chip);
            });

            _this2.props.changeConfigDataValue('custom_audiences', deletedIncludedAudiences);
          }
        }, _this2.props.customAudiences.find(function (ca) {
          return parseInt(ca.facebookId) === parseInt(chip);
        }).audienceName);
      });
      var excludedCustomAudienceChips = this.props.excludedCustomAudiences.map(function (chip, index) {
        return /*#__PURE__*/React.createElement(Chip, {
          key: "excludedCAChip_".concat(index),
          style: {
            marginBottom: 6
          },
          onRequestDelete: function onRequestDelete() {
            var deletedExcludedAudiences = _this2.props.excludedCustomAudiences.filter(function (e) {
              return parseInt(e) !== parseInt(chip);
            });

            _this2.props.changeConfigDataValue('excluded_custom_audiences', deletedExcludedAudiences);
          }
        }, _this2.props.customAudiences.find(function (ca) {
          return parseInt(ca.facebookId) === parseInt(chip);
        }).audienceName);
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, this.props.customAudiences && !!this.props.customAudiences.length && !this.props.gettingCustomAudiences ? /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.state.selectedCustomAudienceType,
        style: {
          width: '100%',
          top: 14
        },
        onChange: function onChange(e, i, val) {
          return _this2.setState({
            selectedCustomAudienceType: val
          });
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: 'Include'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: 'Exclude'
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-8"
      }, /*#__PURE__*/React.createElement(SelectField, {
        style: {
          width: '100%'
        },
        onChange: function onChange(e, i, val) {
          if (_this2.state.selectedCustomAudienceType === 1) {
            var changedCustomAudiences = _toConsumableArray(_this2.props.includedCustomAudiences);

            changedCustomAudiences.push(val);

            _this2.props.changeConfigDataValue('custom_audiences', changedCustomAudiences);
          } else {
            var changedExcludedCustomAudiences = _toConsumableArray(_this2.props.excludedCustomAudiences);

            changedExcludedCustomAudiences.push(val);

            _this2.props.changeConfigDataValue('excluded_custom_audiences', changedExcludedCustomAudiences);
          }
        }
      }, this.props.customAudiences.map(function (audience, i) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "CA_Audience_".concat(i),
          value: audience.facebookId,
          primaryText: audience.audienceName
        });
      })))) : /*#__PURE__*/React.createElement("p", {
        style: {
          color: '#616161'
        }
      }, "No custom audiences...click the button below to build one."), (!!this.props.includedCustomAudiences.length || !!this.props.excludedCustomAudiences.length) && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, !!this.props.includedCustomAudiences.length && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h5", {
        className: styles.targetingRowHeader
      }, "Included Custom Audiences"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, includedCustomAudienceChips)), !!this.props.excludedCustomAudiences.length && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h5", {
        className: styles.targetingRowHeader
      }, "Excluded Custom Audiences"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, excludedCustomAudienceChips))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: 24
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        onClick: function onClick() {
          return _this2.setState({
            showAudienceDialog: true
          });
        },
        className: styles.customAudienceCreate,
        label: "Create New Custom Audience"
      }))), /*#__PURE__*/React.createElement(CABuilder, {
        adAccountId: this.props.adAccountId,
        handleClose: function handleClose() {
          _this2.setState({
            showAudienceDialog: false
          });
        },
        show: this.state.showAudienceDialog
      }));
    }
  }]);

  return AudienceCustom;
}(Component)) || _class);
export { AudienceCustom as default };
AudienceCustom.defaultProps = {};